import { Component } from '@angular/core';

import { Register } from '../../shared';


@Register({
  name: 'timeAnalysis',
  title: 'igo.timeAnalysis',
  icon: 'history'
})
@Component({
  selector: 'igo-time-analysis-tool',
  template: require('./time-analysis-tool.component.html'),
  styles: [require('./time-analysis-tool.component.styl')]
})
export class TimeAnalysisToolComponent {

  constructor() { }

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/tool/tools/time-analysis-tool/time-analysis-tool.component.ts